import api from "./index";
import { ENDPOINTS } from "./endpoints";

/* CREATE */
export const createIndustryGroup = (data) => {
  return api.post(ENDPOINTS.INDUSTRY_GROUPS.CREATE, data);
};

/* SEARCH */
export const listIndustryGroupByParams = (data) => {
  return api.post(ENDPOINTS.INDUSTRY_GROUPS.SEARCH, data);
};

/* GET BY ID */
export const getIndustryGroupById = (id) => {
  return api.get(ENDPOINTS.INDUSTRY_GROUPS.BY_ID(id));
};

/* UPDATE */
export const updateIndustryGroup = (id, data) => {
  return api.put(ENDPOINTS.INDUSTRY_GROUPS.UPDATE(id), data);
};

/* DELETE */
export const deleteIndustryGroup = (id) => {
  return api.delete(ENDPOINTS.INDUSTRY_GROUPS.DELETE(id));
};